import { render, staticRenderFns } from "./MyLifeEventsDashboardItem.vue?vue&type=template&id=95d2c264&scoped=true"
import script from "./MyLifeEventsDashboardItem.vue?vue&type=script&lang=js"
export * from "./MyLifeEventsDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./MyLifeEventsDashboardItem.vue?vue&type=style&index=0&id=95d2c264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d2c264",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VCardText,VCarousel,VCarouselItem,VCol,VImg,VRow,VSheet})
